import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

function HomePage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '韩漫之家',
        url: 'https://hanmanzhijia.com',
        description: '韩漫之家是国内领先的高清韩国漫画在线阅读平台，致力于为中文读者提供最全面、最优质的韩漫阅读体验。',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'contact@hanmanzhijia.com',
          contactType: 'customer service',
        },
      },
      {
        '@type': 'WebSite',
        name: '韩漫之家',
        url: 'https://hanmanzhijia.com',
        description: '韩漫大全 - 高清韩国漫画免费在线阅读平台',
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'WebPage',
        name: '韩漫之家 - 首页',
        description: '韩漫大全_高清韩国漫画_漫画韩漫网址_免费韩漫在线阅读-韩漫之家',
        url: 'https://hanmanzhijia.com',
        isPartOf: {
          '@type': 'WebSite',
          name: '韩漫之家',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="韩漫大全_高清韩国漫画_漫画韩漫网址_免费韩漫在线阅读-韩漫之家"
        description="韩漫之家带来全面的韩漫大全，专注于高清韩国漫画的免费在线阅读，通过友好网址访问，让您探索各类故事，提升阅读体验。收录最新韩国漫画、热门韩漫推荐、分类齐全的韩漫资源。"
        keywords="韩漫大全,高清韩国漫画,漫画韩漫网址,免费韩漫在线阅读,韩漫之家"
        canonicalUrl="https://hanmanzhijia.com"
        jsonLd={jsonLd}
      />

      <HeroSection />
      <CategorySection />
      <FeaturedSection />
      <LatestSection />
      <FAQSection />
      <CTASection />
    </>
  );
}

export default HomePage;